export default __webpack_public_path__ + "static/media/NeueMontreal-Light.11616ccd.woff2";